<template>
  <div class="forpay-wrapper">
    <!-- Header -->
    <div class="forpay-header">
      <div class="contract-info">
        <div class="contract-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
            />
          </svg>
        </div>
        <div class="contract-details">
          <span class="contract-label">Pagos Automáticos</span>
          <span class="contract-number">Forpay</span>
        </div>
      </div>
      <div class="status-badge" :class="forpayMandate ? 'active' : 'inactive'">
        <svg
          v-if="forpayMandate"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" x2="12" y1="8" y2="12" />
          <line x1="12" x2="12.01" y1="16" y2="16" />
        </svg>
        <span>{{ forpayMandate ? "Afiliado" : "Sin afiliar" }}</span>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="loading-state">
      <div class="skeleton-content">
        <div class="skeleton-card">
          <div class="skeleton-icon"></div>
          <div class="skeleton-lines">
            <div class="skeleton-line long"></div>
            <div class="skeleton-line medium"></div>
            <div class="skeleton-line short"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Already Affiliated View -->
    <div v-else-if="forpayMandate" class="forpay-content">
      <div class="success-banner">
        <div class="success-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
        <div class="success-text">
          <h3>¡Ya estás afiliado a Forpay!</h3>
          <p>Tus pagos se realizarán automáticamente cada mes</p>
        </div>
      </div>

      <div class="mandate-card">
        <div class="mandate-header">
          <div class="mandate-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect width="20" height="14" x="2" y="5" rx="2" />
              <line x1="2" x2="22" y1="10" y2="10" />
            </svg>
          </div>
          <span>Detalle del Mandato</span>
        </div>
        <div class="mandate-details">
          <div class="detail-row">
            <span class="detail-label">Tipo de pago</span>
            <span class="detail-value">
              <span
                class="type-badge"
                :class="
                  forpayMandate.forpay_mandate_type === 'CREDIT'
                    ? 'credit'
                    : 'debit'
                "
              >
                <svg
                  v-if="forpayMandate.forpay_mandate_type === 'CREDIT'"
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect width="20" height="14" x="2" y="5" rx="2" />
                  <line x1="2" x2="22" y1="10" y2="10" />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect width="20" height="14" x="2" y="5" rx="2" />
                  <line x1="2" x2="22" y1="10" y2="10" />
                </svg>
                {{ getMandateType(forpayMandate.forpay_mandate_type) }}
              </span>
            </span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Medio de pago</span>
            <span class="detail-value">{{
              getMandateMedium(forpayMandate.forpay_mandate_number)
            }}</span>
          </div>
          <div
            class="detail-row"
            v-if="forpayMandate.forpay_mandate_type == 'CREDIT'"
          >
            <span class="detail-label">Número de tarjeta</span>
            <span class="detail-value card-number">{{
              getMandateNumber(forpayMandate.forpay_mandate_number)
            }}</span>
          </div>
        </div>
      </div>

      <div class="info-note">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
        <p>
          Si deseas cambiar tu medio de pago, puedes afiliarte nuevamente con
          otra cuenta o tarjeta.
        </p>
      </div>
    </div>

    <!-- Not Affiliated View -->
    <div v-else class="forpay-content">
      <div class="hero-section">
        <div class="hero-illustration">
          <div class="floating-icons">
            <div class="icon-float calendar">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                <line x1="16" x2="16" y1="2" y2="6" />
                <line x1="8" x2="8" y1="2" y2="6" />
                <line x1="3" x2="21" y1="10" y2="10" />
                <path d="m9 16 2 2 4-4" />
              </svg>
            </div>
            <div class="icon-float check">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
            <div class="icon-float bell">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
              </svg>
            </div>
            <div class="icon-float money">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                />
              </svg>
            </div>
          </div>
          <img
            :src="require('@/assets/images/working.png')"
            alt="Pagos Automáticos"
            class="hero-image"
          />
        </div>
        <div class="hero-content">
          <h2 class="hero-title">¡Olvídate de pagar tus cuotas manualmente!</h2>
          <p class="hero-description">
            Con Forpay puedes automatizar todos tus pagos mes a mes usando tu
            cuenta corriente o la tarjeta de crédito que prefieras.
          </p>
          <ul class="hero-benefits">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Pagos puntuales sin retrasos
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              100% seguro y confiable
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Puedes cancelarlo cuando quieras
            </li>
          </ul>
        </div>
      </div>

      <div class="action-card">
        <div class="action-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect width="20" height="14" x="2" y="5" rx="2" />
            <line x1="2" x2="22" y1="10" y2="10" />
            <path d="M6 14h.01" />
            <path d="M10 14h4" />
          </svg>
        </div>
        <div class="action-content">
          <h3>Conecta tu cuenta o tarjeta</h3>
          <p>
            Serás redirigido a Forpay para completar la afiliación de forma
            segura.
          </p>
        </div>
        <button
          class="action-btn"
          @click="add_forpay(contract_id)"
          :disabled="loading"
        >
          <span v-if="!loading">Afiliarse a Forpay</span>
          <span v-else class="loading-spinner">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="spin"
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
            Procesando...
          </span>
          <svg
            v-if="!loading"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </div>

      <div class="security-note">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
          <path d="m9 12 2 2 4-4" />
        </svg>
        <p>
          Tus datos están protegidos con encriptación de nivel bancario. No
          almacenamos información sensible de tus cuentas.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "paymentOptions",
  components: {},
  props: {
    asset_id: null,
    project_id: { default: null },
  },
  data() {
    return {
      showForpay: null,
      loading: false,
      forpayMandate: null,
    };
  },
  mounted() {
    this.getForpayMandates();
  },
  computed: {
    contract_id() {
      return this.$store.getters.getContractId == undefined
        ? null
        : this.$store.getters.getContractId;
    },
    gcVersion() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
  },
  methods: {
    checkForpay() {
      return true;
    },
    getForpayMandates() {
      let self = this;
      this.axios
        .get(`payments/get_forpay_mandates?contract_id=${this.contract_id}`)
        .then((result) => {
          self.forpayMandate = result.data;
          this.$store.commit("setForpayMandate", result.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    add_forpay(contract_id) {
      // Validar que contract_id no sea null
      if (!contract_id) {
        this.$swal(
          "Oops",
          "No se pudo identificar el contrato. Por favor recarga la página e intenta nuevamente.",
          "error"
        );
        return;
      }

      console.log(contract_id);
      this.loading = true;
      this.axios
        .post("payments/forpay", {
          contract_id: contract_id,
        })
        .then((result) => {
          let url_redirect = result.data.url;
          // Validar que la URL sea válida y no contenga 'null'
          if (
            !url_redirect ||
            url_redirect == "" ||
            url_redirect.includes("null")
          ) {
            this.$swal(
              "Oops",
              "hubo un error agregando tu pago, favor intentar más tarde if redirect",
              "error"
            );
            this.loading = false;
          } else {
            window.location.href = url_redirect;
          }
        })
        .catch(() => {
          this.$swal(
            "Oops",
            "hubo un error agregando tu pago, favor intentar más tarde 500",
            "error"
          );
          this.loading = false;
        });
    },
    getMandateType(type) {
      if (type == "CREDIT") return "Tarjeta de crédito";
      if (type == "DEBIT") return "Débito";
      return type;
    },
    getMandateNumber(number) {
      return "**** **** **** " + number.slice(-4);
    },
    getMandateMedium(medium) {
      return medium.split(" -")[0];
    },
  },
  watch: {
    contract_id: function (new_val) {
      if (new_val) this.getForpayMandates();
    },
  },
};
</script>
<style scoped>
.forpay-wrapper {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* Header */
.forpay-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(135deg, #fafafa, #ffffff);
}

.contract-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.contract-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, var(--color-btn, #3b82f6), #60a5fa);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contract-icon svg {
  color: white;
}

.contract-details {
  display: flex;
  flex-direction: column;
}

.contract-label {
  font-size: 0.8rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.contract-number {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.status-badge.active {
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  color: #059669;
}

.status-badge.inactive {
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  color: #d97706;
}

/* Content */
.forpay-content {
  padding: 24px;
}

/* Loading State */
.loading-state {
  padding: 40px 24px;
}

.skeleton-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px;
  background: #f9fafb;
  border-radius: 12px;
}

.skeleton-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 12px;
}

.skeleton-lines {
  flex: 1;
}

.skeleton-line {
  height: 12px;
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 6px;
  margin-bottom: 10px;
}

.skeleton-line.long {
  width: 80%;
}
.skeleton-line.medium {
  width: 60%;
}
.skeleton-line.short {
  width: 40%;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Success Banner */
.success-banner {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  border-radius: 12px;
  margin-bottom: 20px;
}

.success-icon {
  width: 56px;
  height: 56px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.success-icon svg {
  color: #059669;
}

.success-text h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #065f46;
  margin: 0 0 4px 0;
}

.success-text p {
  font-size: 0.9rem;
  color: #047857;
  margin: 0;
}

/* Mandate Card */
.mandate-card {
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  margin-bottom: 16px;
}

.mandate-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  background: white;
  border-bottom: 1px solid #e5e7eb;
}

.mandate-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--color-btn, #3b82f6), #60a5fa);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mandate-icon svg {
  color: white;
  width: 18px;
  height: 18px;
}

.mandate-header span {
  font-weight: 600;
  color: #374151;
}

.mandate-details {
  padding: 16px 20px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 0.9rem;
  color: #6b7280;
}

.detail-value {
  font-weight: 600;
  color: #1f2937;
}

.type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.85rem;
}

.type-badge.credit {
  background: linear-gradient(135deg, #ede9fe, #ddd6fe);
  color: #7c3aed;
}

.type-badge.debit {
  background: linear-gradient(135deg, #dbeafe, #bfdbfe);
  color: #2563eb;
}

.card-number {
  font-family: "Courier New", monospace;
  letter-spacing: 1px;
}

/* Info Note */
.info-note {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  background: #f0f9ff;
  border-radius: 10px;
  border: 1px solid #bae6fd;
}

.info-note svg {
  color: #0284c7;
  flex-shrink: 0;
  margin-top: 1px;
}

.info-note p {
  font-size: 0.85rem;
  color: #0369a1;
  margin: 0;
  line-height: 1.5;
}

/* Hero Section */
.hero-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  margin-bottom: 30px;
}

.hero-illustration {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-image {
  max-width: 100%;
  max-height: 220px;
  object-fit: contain;
  position: relative;
  z-index: 1;
}

.floating-icons {
  position: absolute;
  inset: 0;
  z-index: 2;
}

.icon-float {
  position: absolute;
  background: white;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  animation: float 3s ease-in-out infinite;
}

.icon-float svg {
  color: var(--color-btn, #3b82f6);
}

.icon-float.calendar {
  top: 5%;
  right: 10%;
  animation-delay: 0s;
}

.icon-float.check {
  bottom: 10%;
  left: 5%;
  animation-delay: 0.5s;
}

.icon-float.bell {
  top: 0%;
  left: 10%;
  animation-delay: 1s;
}

.icon-float.money {
  bottom: 15%;
  right: 0%;
  animation-delay: 1.5s;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.hero-content {
  padding-right: 20px;
}

.hero-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.hero-description {
  font-size: 0.95rem;
  color: #6b7280;
  line-height: 1.6;
  margin: 0 0 20px 0;
}

.hero-benefits {
  list-style: none;
  padding: 0;
  margin: 0;
}

.hero-benefits li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 0.9rem;
  color: #374151;
}

.hero-benefits li svg {
  color: #10b981;
  flex-shrink: 0;
}

/* Action Card */
.action-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px;
  background: linear-gradient(135deg, #f0fdf4, #dcfce7);
  border-radius: 16px;
  border: 1px solid #bbf7d0;
  margin-bottom: 20px;
}

.action-icon {
  width: 64px;
  height: 64px;
  background: white;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.action-icon svg {
  color: #16a34a;
}

.action-content {
  flex: 1;
}

.action-content h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #166534;
  margin: 0 0 4px 0;
}

.action-content p {
  font-size: 0.85rem;
  color: #15803d;
  margin: 0;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #16a34a, #22c55e);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.action-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #15803d, #16a34a);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
}

.action-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  display: flex;
  align-items: center;
  gap: 8px;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Security Note */
.security-note {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.security-note svg {
  color: #059669;
  flex-shrink: 0;
  margin-top: 2px;
}

.security-note p {
  font-size: 0.85rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

/* Responsive */
@media (max-width: 768px) {
  .forpay-header {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .contract-info {
    flex-direction: column;
    text-align: center;
  }

  .hero-section {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .hero-illustration {
    order: -1;
  }

  .hero-image {
    max-height: 180px;
  }

  .hero-content {
    padding: 0;
    text-align: center;
  }

  .hero-title {
    font-size: 1.3rem;
  }

  .hero-benefits {
    display: inline-block;
    text-align: left;
  }

  .action-card {
    flex-direction: column;
    text-align: center;
  }

  .action-content {
    text-align: center;
  }

  .action-btn {
    width: 100%;
    justify-content: center;
  }

  .success-banner {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 576px) {
  .forpay-header {
    padding: 16px;
  }

  .forpay-content {
    padding: 16px;
  }

  .hero-title {
    font-size: 1.2rem;
  }

  .hero-description {
    font-size: 0.9rem;
  }

  .action-card {
    padding: 16px;
  }

  .action-icon {
    width: 50px;
    height: 50px;
  }

  .action-icon svg {
    width: 24px;
    height: 24px;
  }

  .mandate-card,
  .success-banner {
    padding: 16px;
  }

  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}
</style>
